import React from 'react';
import styled, { css } from 'styled-components';

import type HTMLProps from '@zimpel/common/HTMLProps';
import type { IconType } from '../Icon';

const Element = styled.div<{ $hasBorderTop?: boolean, $hasBorderBottom?: boolean }>`
  padding: 5px 10px;
  ${({ $hasBorderTop }) => $hasBorderTop && css`
    border-top: var(--border-box);
  `}
  ${({ $hasBorderBottom }) => $hasBorderBottom && css`
    border-bottom: var(--border-box);
  `}
`;

type Props = {
  icon?: IconType;
  borderTop?: boolean;
  borderBottom?: boolean;
} & HTMLProps & React.PropsWithChildren;

const AutoCompleteElement: React.FC<Props> = ({
  icon,
  borderTop = false,
  borderBottom = false,
  children,
  ...props
}) => (
  <Element
    $hasBorderTop={borderTop}
    $hasBorderBottom={borderBottom}
    {...props}
  >
    {icon && React.createElement(icon, { fixedWidth: true })}
    {children}
  </Element>
);

const AutoCompleteElementExtraInfo = styled.div`
  font-size: var(--font-size-small);
  color: var(--color-text-secondary);
`;

export default AutoCompleteElement;
export { AutoCompleteElementExtraInfo };
